import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import titleize from 'titleize'
import KEYCODE from 'keycode'

import ClickOutside from '../clickOutside'
import OnKeyDown from '../onKeyDown'
import { parseLocation } from '../../../common/utils/urlHelper'
import FiltersSingleSelectPanel from './filtersPanel/singleSelect'
import { reportOpenSearchFilterPanel } from '../../../common/analytics/filtersAnalytics'

class FiltersSoftwareVersion extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showPanel: false
    }

    this.togglePanel = this.togglePanel.bind(this)
    this.onKeyDownHandler = this.onKeyDownHandler.bind(this)
  }

  onKeyDownHandler (event) {
    if (event.keyCode === KEYCODE('esc')) {
      this.togglePanel()
    }
  }

  togglePanel () {
    if (!this.state.showPanel) {
      reportOpenSearchFilterPanel('Software version')
    }
    this.setState({
      showPanel: !this.state.showPanel
    })
  }

  filterOption (items, chosenPlatform) {
    return items.filter((item, idx) => {
      return item.key.indexOf(chosenPlatform) > -1 && item.key !== chosenPlatform
    })
  }

  render () {
    const { showPanel } = this.state
    const { items, location, platformRootCount } = this.props
    const parsedLocation = parseLocation(location)

    const chosenPlatform = parsedLocation.platform || ''
    const chosenPlatformArray = chosenPlatform.split(' ')
    const chosenPlatformLength = chosenPlatformArray.length
    const filteredPlatformItems = this.filterOption(items, chosenPlatform)

    const renderChosenPlatform = () => {
      if (chosenPlatform === '') {
        return (
          <ul className='search-facet-listing'>
            {items.map((item, index) => {
              return (
                <li key={index}>
                  <div className='search-facet-listing__link'>
                    <span className='search-facet-listing__label'>{titleize(item.key)}</span>
                    <span className='search-facet-result-count'>{item.count}</span>
                  </div>
                </li>
              )
            })}
          </ul>
        )
      } else {
        const getChosenPlatformDisplayName = (chosenPlatform) => {
          return chosenPlatformArray.map((platformName, index) => {
            const isLast = index === chosenPlatformLength - 1
            return (
              <div key={index} className='search-facet-panel__status-title'>
                {titleize(platformName)}
                {!isLast &&
                  <i className='e-icon -icon-arrow-fill-right' />
                }
              </div>
            )
          })
        }
        return (
          <div className='search-facet-panel__status fds-u-is-hidden--no-js'>
            <div className='search-facet-panel__status-row'>
              {getChosenPlatformDisplayName(chosenPlatform)}
            </div>
          </div>
        )
      }
    }

    const { isAtBottom } = this.props
    const panelHeaderClassNames = classNames(
      'search-facet-panel__header--start', {
        'search-facet-panel__header--one-facet': isAtBottom,
        'search-facet-panel__header--end': isAtBottom,
        'is-active': showPanel
      }
    )

    return (
      <div className='search-facet--no-margin' id='software-version-filter'>
        <div className={panelHeaderClassNames} onClick={this.togglePanel}>
          <h2>
            <i className='e-icon -icon-code -margin-right' />
            Software version
          </h2>
          {renderChosenPlatform()}
        </div>

        {showPanel &&
          <OnKeyDown onKeyDown={this.onKeyDownHandler}>
            <ClickOutside onClickOutside={this.togglePanel}>
              <FiltersSingleSelectPanel
                rootCount={platformRootCount}
                showPanel={showPanel}
                items={filteredPlatformItems}
                parsedLocation={parsedLocation}
                togglePanel={this.togglePanel}
                breadcrumbsLabel='software versions'
                type='platform'
              />
            </ClickOutside>
          </OnKeyDown>
        }
      </div>
    )
  }
}

FiltersSoftwareVersion.propTypes = {
  items: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
  platformRootCount: PropTypes.number.isRequired
}

export default FiltersSoftwareVersion



// WEBPACK FOOTER //
// ./client/components/filters/filtersSoftwareVersion.js